<!-- High-Density Header Control Action Toolbar Pane Wrapper -->
<div
  class="d-flex flex-wrap align-items-center justify-content-between p-3 rounded-4 border shadow-sm bg-body-tertiary">

  <!-- Left Side: Navigation Back Link Anchor -->
  <div>
    <a class="btn btn-sm btn-outline-secondary d-inline-flex align-items-center gap-1.5 px-3 py-2 shadow-sm text-body fw-semibold transition-base"
      routerLink="/nav/qr-code-list">
      <i class="bi bi-arrow-left"></i>
      <span>Back to List</span>
    </a>
  </div>

  <!-- Right Side: Dynamic Security Access Multi-Access Governance Commands -->
  @if (isUpdateEnableDisable()) {
  <div class="d-flex align-items-center gap-2 ms-auto">

    <!-- Update Points Operational Weight Modifier -->
    @if (qrcodeitem()?.claimCustomerLoginPhone === null) {
    <button type="button"
      class="btn btn-sm btn-primary px-3 py-2 shadow-sm d-inline-flex align-items-center gap-1.5 fw-semibold transition-base micro-action-btn"
      [disabled]="operationLoading()" (click)="updatepoints()">
      <i class="bi bi-sliders"></i>
      <span>Update Points</span>
    </button>
    }

    <!-- Dynamic Visibility State Activation Switches -->
    <div>
      @if (qrcodeitem()?.claimCustomerLoginPhone === null && !qrcodeitem()?.enabled && qrcodeitem()?.luckyDrawName) {
      <button type="button"
        class="btn btn-sm btn-success px-3 py-2 shadow-sm d-inline-flex align-items-center gap-1.5 fw-semibold transition-base micro-action-btn"
        [disabled]="operationLoading()" (click)="enableQrcode('enabled')">
        <i class="bi bi-check-circle"></i>
        <span>Enable QrCode</span>
      </button>
      }
      @if (qrcodeitem()?.claimCustomerLoginPhone === null && qrcodeitem()?.enabled) {
      <button type="button"
        class="btn btn-sm btn-danger px-3 py-2 shadow-sm d-inline-flex align-items-center gap-1.5 fw-semibold transition-base micro-action-btn"
        [disabled]="operationLoading()" (click)="enableQrcode('disabled')">
        <i class="bi bi-ban"></i>
        <span>Disable QrCode</span>
      </button>
      }
    </div>

  </div>
  }
</div>

<!-- High-Density Document Parameter Metadata Card Blueprint -->
@if (qrcodeitem()) {
<div class="card border shadow-sm rounded-4 bg-body overflow-hidden w-100 mt-4 me-3">
  <div class="table-responsive m-0">
    <table class="table table-hover align-middle mb-0 table-dense" style="table-layout: fixed; width: 100%;">

      <!-- Table Header Matrix Title -->
      <thead class="table-light text-body-secondary border-bottom font-monospace font-xs text-uppercase tracking-wider">
        <tr>
          <th scope="col" colspan="2" class="ps-4 py-2.5 fw-bold">
            <i class="fa-solid fa-qrcode me-2 text-primary"></i>QR Code Data Details
          </th>
        </tr>
      </thead>

      <!-- Structural Parameter Key/Value Ledger Rows -->
      <tbody class="font-xs text-body">

        <tr class="transition-base">
          <td class="ps-4 text-body-secondary fw-bold font-monospace text-uppercase tracking-wider" style="width: 25%;">
            Serial number</td>
          <td class="font-monospace fw-bold fs-6 text-body">{{ qrcodeitem().serialNumber | uppercase }}</td>
        </tr>

        <tr class="transition-base">
          <td class="ps-4 text-body-secondary fw-bold font-monospace text-uppercase tracking-wider">QR code</td>
          <td class="font-monospace text-body-secondary font-xs text-truncate" [title]="qrcodeitem().qrCode">{{
            qrcodeitem().qrCode }}</td>
        </tr>

        <tr class="transition-base">
          <td class="ps-4 text-body-secondary fw-bold font-monospace text-uppercase tracking-wider">Points</td>
          <td class="font-monospace fw-bold text-success-emphasis fs-6">{{ qrcodeitem().points | number }} pts</td>
        </tr>

        <tr class="transition-base">
          <td class="ps-4 text-body-secondary fw-bold font-monospace text-uppercase tracking-wider">Qr code Enabled</td>
          <td>
            <span
              class="badge rounded-pill px-2.5 py-1.5 font-xs fw-semibold tracking-wide d-inline-flex align-items-center gap-1.5"
              [ngClass]="qrcodeitem().enabled ? 'bg-success-subtle text-success-emphasis border border-success-subtle' : 'bg-danger-subtle text-danger-emphasis border border-danger-subtle'">
              <i [ngClass]="qrcodeitem().enabled ? 'bi bi-check-circle-fill' : 'bi bi-x-circle-fill'"></i>
              {{ qrcodeitem().enabled ? 'ENABLED' : 'DISABLED' }}
            </span>
          </td>
        </tr>

        <tr class="transition-base">
          <td class="ps-4 text-body-secondary fw-bold font-monospace text-uppercase tracking-wider">Lucky draw name</td>
          <td class="fw-medium text-body">{{ qrcodeitem().luckyDrawName || '-' }}</td>
        </tr>

        <tr class="transition-base">
          <td class="ps-4 text-body-secondary fw-bold font-monospace text-uppercase tracking-wider">Claim timestamp</td>
          <td class="text-body-secondary font-monospace">{{ qrcodeitem().claimTimeStamp ? (qrcodeitem().claimTimeStamp |
            dateFormat) : 'Unclaimed' }}</td>
        </tr>

        <tr class="transition-base">
          <td class="ps-4 text-body-secondary fw-bold font-monospace text-uppercase tracking-wider">Customer phone</td>
          <td>
            @if (qrcodeitem().claimCustomerLoginPhone) {
            <a class="font-monospace fw-semibold text-primary fs-6"
              [routerLink]="['/nav/customer-info', qrcodeitem().claimCustomerLoginPhone]">{{
              qrcodeitem().claimCustomerLoginPhone }}</a>
            } @else {
            <span class="text-body-secondary opacity-50 fst-italic">Unclaimed</span>
            }
          </td>
        </tr>

        <tr class="transition-base">
          <td class="ps-4 text-body-secondary fw-bold font-monospace text-uppercase tracking-wider">Has illegal claim
          </td>
          <td>
            <span class="badge px-2.5 py-1.5 rounded-pill font-xs fw-semibold"
              [ngClass]="qrcodeitem().hasIllegalClaims ? 'bg-danger-subtle text-danger-emphasis border border-danger-subtle' : 'bg-success-subtle text-success-emphasis border border-success-subtle'">
              {{ qrcodeitem().hasIllegalClaims ? 'SUSPECT CRITICAL' : 'CLEAR SAFE' }}
            </span>
          </td>
        </tr>

        <tr class="transition-base">
          <td class="ps-4 text-body-secondary fw-bold font-monospace text-uppercase tracking-wider">Illegal claim type
          </td>
          <td class="text-uppercase font-monospace font-xs text-danger-emphasis fw-semibold">{{
            qrcodeitem().illegalClaimType || 'NONE' }}</td>
        </tr>

      </tbody>
    </table>
  </div>
</div>
}

<!-- Non-Blocking Small Corner Card Loader Syncing Anchor -->
@if (loading() || operationLoading()) {
<div
  class="position-fixed bottom-0 end-0 m-2 z-3 p-1.5 bg-body card border-info border-opacity-25 shadow-sm d-flex flex-row align-items-center gap-2"
  style="backdrop-filter: blur(4px); min-height: 38px;">
  <div class="spinner-border text-info" style="width: 1rem; height: 1rem; border-width: 2px;" role="status">
    <span class="visually-hidden">Loading...</span>
  </div>
  <div class="font-monospace text-info fw-bold tracking-widest text-uppercase pe-1 font-xs">
    Syncing...
  </div>
</div>
}